import { useRef } from 'react';
import type { ReactElement } from 'react';
import { setupEmailEnterTimeline, setupEmailLeaveTimeline } from './OfficeEmail.transitions';
import styles from './Location.module.scss';
import Heading from '../../atoms/heading/Heading';
import Text from '../../atoms/text/Text';
import { useScrollTransition } from '../../../util/react-transition-component';
import type { Email } from '../emails/Emails.data';

type OfficeEmailProps = {
  email: Email;
};
export const OfficeEmail = ({ email }: OfficeEmailProps): ReactElement => {
  const emailTitleRef = useRef<HTMLDivElement>(null);
  const emailAddressRef = useRef<HTMLParagraphElement>(null);
  const elementRef = useRef<HTMLLIElement>(null);

  useScrollTransition({
    scroll: {
      trigger: elementRef,
    },
    setupOptions: () => ({
      ref: elementRef,
      refs: {
        emailTitleRef,
        emailAddressRef,
      },
      setupTransitionInTimeline: setupEmailEnterTimeline,
      setupTransitionOutTimeline: setupEmailLeaveTimeline,
    }),
  });

  return (
    <li className={styles.emailContainer} ref={elementRef}>
      <Heading
        as="span"
        size="label-small"
        disableTriggerInOnScroll
        transitionInType="splitWordsSlideInUp"
        transitionOutType="fadeOut"
        className={styles.emailTitle}
        ref={emailTitleRef}
      >
        {email.title}
      </Heading>
      <Text
        as="p"
        size="body-standard"
        disableTriggerInOnScroll
        transitionInType="splitLineRotateIn"
        transitionOutType="fadeOut"
        className={styles.emailAddress}
        ref={emailAddressRef}
      >
        <a href={`mailto:${email.email_address}`}>{email.email_address}</a>
      </Text>
    </li>
  );
};
